import React from 'react'
import './TextArea.css'

export default function TextArea(props) {
    return (
        <div className='textAreaContainer' style={props.containerStyles}>
            <p className='textAreaTitle' style={props.titleStyles}>{props.title}</p>
            <textarea className='textAreaBody' value={props.value} onChange={props.onChange} style={props.inputStyles} name={props.name}/>
            <span className="error">{props.formSubmitted && props.errors}</span>
        </div>
    )
}
